import { useContext } from 'react';

import FunctionContext from '../../ScrollToBottom/FunctionContext';

export default function useFunctionContext() {
  return useContext(FunctionContext);
}
